import React, { useState, useEffect } from "react";
import { Grid, IconButton, Paper } from "@material-ui/core";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  Checkbox,
  TableBody,
  Typography,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Delete } from "@material-ui/icons";
// import "./style.css";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import Heading from "../../../../StyledComponents/Heading/Heading";
import {
  DataSheetGrid,
  checkboxColumn,
  textColumn,
  keyColumn,
  intColumn,
  floatColumn,
  resizeColumn,
} from "react-datasheet-grid";
import "react-datasheet-grid/dist/style.css";
import Stack from "@mui/material/Stack";

import LinearProgress from "@mui/material/LinearProgress";

const useStyles = makeStyles({
  table: {
    minWidth: 650,

    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
  inputStyle: {
    outline: "none",
    border: "none",

    // borderBottom: "1px solid black",
    // backgroundColor: item?.selected && "rgb(240,240,240)",
    width: "100px",
  },
});

function PoDetail_Table_Import({
  formState,
  setSelectedTotal,
  setFormState,
  deletee,
  Invoice_id,
  checkedBox,
  loading,
  edit,
}) {
  const tableData = {
    po_Ref_Id: 0,
    reF_DOC_IT: "",
    val_Loccur: "",
    currency: "",
    quantity: "",
    delivUnit: "",
    poNumber: "",
    poItem: "",
    poItemText: "",
    refDoc: "",
    plant: "",
    uniT_PRICE : "",
    reF_DOC_NO: "",
    reF_DOC_NO_LONG: "",
    assetNumber: "",
    kschl: "",
    vText: "",
    invoice_Id: Number(Invoice_id),
    created_by: "",
    created_on: "",
    invoicE_QTY: 0,
    invoicE_VAL: 0,
    balancE_QTY: "",
    balancE_VAL: "",
    inpuT_QTY: 0,
    inpuT_VAL: 0,
    conD_ST_NO: "",
    conD_COUNT: "",
    doC_YEAR: "",
    sheeT_ITEM: "",
    dN_NO: "",
    seQ_NO: "",
    disT_IND: "",
    ordeR_UNIT: "",
    ordeR_QTY: "",
    sO_NO: "",
    sO_ITEM: "",
    doc_Date: "",
    selected: false,
  };
  const classes = useStyles();

  // function to compare selected PO records GRN Amount with Invoice Amount so we can proceed
  const checkBal = (tempArray) => {
    let t = 0;
    let totalItems = tempArray.filter((data) => data.selected == true);
    t = tempArray
      .map((balance) => Number((balance?.inpuT_VAL || 0)?.toFixed(2)))
      .reduce((total, item) => total + item, 0);
    setSelectedTotal(t);
  };

  const addInput = () => {
    setFormState((formState) => ({
      ...formState,
      invoicePORef_List: [...formState.invoicePORef_List, tableData],
    }));
  };

  const deleteInput = (index) => {
    const filteredData = formState?.invoicePORef_List?.filter(
      (x, i) => i !== index
    );
    setFormState((formState) => ({
      ...formState,
      invoicePORef_List: filteredData,
    }));
    checkBal(filteredData);
  };

  //
  const changeHandler = (e, index) => {
    const { name, value } = e.target;

    if (name === "val_Loccur") {
      let tempArray = formState.invoicePORef_List;

      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_VAL: (
          Number(value) - Number(tempArray[index].invoicE_VAL)
        ).toString(),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "invoicE_VAL") {
      let tempArray = formState.invoicePORef_List;

      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_VAL: (
          Number(tempArray[index].val_Loccur) - Number(value)
        ).toString(),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "quantity") {
      let tempArray = formState.invoicePORef_List;
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_QTY: Number(value) - Number(tempArray[index].invoicE_QTY),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "invoicE_QTY") {
      let tempArray = formState.invoicePORef_List;
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_QTY: (
          Number(tempArray[index].quantity) - Number(value)
        ).toString(),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "inpuT_QTY") {
      let tempArray = formState.invoicePORef_List;
      if (
        value <=
        Number(tempArray[index].quantity) - Number(tempArray[index].invoicE_QTY)
      ) {
        tempArray[index] = {
          ...formState.invoicePORef_List[index],
          [name]: Number(value),
          inpuT_VAL: Number(
            (
              (Number(tempArray[index].val_Loccur) /
                Number(tempArray[index].quantity)) *
              Number(value)
            )?.toFixed(2)
          ),
        };
        setFormState((formState) => ({
          ...formState,
          invoicePORef_List: tempArray,
        }));
        checkBal(tempArray);
      }
    } else if (name === "inpuT_VAL") {
      let tempArray = formState.invoicePORef_List;
      // if (
      //   value <=
      //   Number(tempArray[index].val_Loccur) -
      //   Number(tempArray[index].invoicE_VAL)
      // ) {
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: Number(Number(value)?.toFixed(2)),
      };
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
      // }
    } else {
      let tempArray = formState.invoicePORef_List;
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
      };
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    }
  };
  const selectRec = (e, index) => {
    if (e.target.checked == true) {
      let tempArray = formState.invoicePORef_List;

      tempArray[index].selected = true;
      setFormState({
        ...formState,
        invoicePORef_List: tempArray,
      });
      checkBal(tempArray);
    } else {
      let tempArray = formState.invoicePORef_List;
      tempArray[index].selected = false;

      setFormState({
        ...formState,
        invoicePORef_List: tempArray,
      });
      checkBal(tempArray);
    }

    // if (e.target.checked == true) {
    //   setSelected_PoRec((selected_PoRec) => ({
    //     ...selected_PoRec,
    //     invoicePORef_List: [...selected_PoRec.invoicePORef_List, item],
    //   }));
    // } else {
    //   const filteredData = selected_PoRec?.invoicePORef_List?.filter(
    //     (x) => x !== item
    //   );
    //   setSelected_PoRec((selected_PoRec) => ({
    //     ...selected_PoRec,
    //     invoicePORef_List: filteredData,
    //   }));
    // }
  };
  // PO Qty   PO Amt these column comment

  useEffect(() => {
    if (formState.length > 0) {
    }
  }, [formState]);
  const [cellState, setCellState] = useState("");

  const handleGridChange = (data, operation, pr1, pr2, pr3, pr4) => {
    // let rowIndex = cellState?.cell?.row;
    let rowIndex = operation[0].fromRowIndex;

    let name = cellState?.cell?.colId;
    let tempArray = data;

    // for consumed quantity
    if (name === "selected") {
      if (tempArray[rowIndex]?.selected === true) {
        tempArray[rowIndex].selected = true;
        setFormState({
          ...formState,
          invoicePORef_List: tempArray,
        });
        checkBal(tempArray);
      } else {
        let tempArray = formState.invoicePORef_List;
        tempArray[rowIndex].selected = false;

        setFormState({
          ...formState,
          invoicePORef_List: tempArray,
        });
        checkBal(tempArray);
      }
    }
    if (name === "quantity") {
      //  GRN quantity
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        // [name]: Number(value).toFixed(0),
        quantity: Number(tempArray[rowIndex].quantity),
        inpuT_QTY:
          Number(tempArray[rowIndex].quantity) -
          // Number(value).toFixed(0) -
          Number(tempArray[rowIndex].invoicE_QTY),
        // Number(tempArray[index].INVOICE_QTY).toFixed(0),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "invoicE_QTY") {
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        // [name]: Number(value).toFixed(0),
        invoicE_QTY: Number(tempArray[rowIndex].invoicE_QTY),
        inpuT_QTY:
          Number(tempArray[rowIndex].quantity) -
          // Number(tempArray[index].Quantity).toFixed(0) -
          Number(tempArray[rowIndex].invoicE_QTY),
        // Number(value).toFixed(0),
        // INPUT_VAL:Number(tempArray[index].Val_Loccur) - Number(tempArray[index].Val_Loccur)/Number( tempArray[index].Quantity)*Number(value)
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "val_Loccur") {
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        val_Loccur: Number(tempArray[rowIndex].val_Loccur),
        inpuT_VAL: Number(
          (
            Number(tempArray[rowIndex].val_Loccur) -
            Number(tempArray[rowIndex].invoicE_VAL)
          )?.toFixed(2)
        ),
        // INVOICE_VAL: Number(value)/Number( tempArray[index].Quantity)*Number(tempArray[index].INVOICE_QTY)
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "invoicE_VAL") {
      // consumed Amount
      if (
        tempArray[rowIndex].invoicE_VAL <=
        (Number(tempArray[rowIndex].val_Loccur) / // GRN amount
          Number(tempArray[rowIndex].quantity)) * // GRN quantity
          Number(tempArray[rowIndex].invoicE_QTY) //  consumed quantity
      ) {
        tempArray[rowIndex] = {
          ...formState.invoicePORef_List[rowIndex],
          invoicE_VAL: Number(tempArray[rowIndex].invoicE_VAL),
          inpuT_VAL: Number(
            (
              Number(tempArray[rowIndex].val_Loccur) -
              Number(tempArray[rowIndex].invoicE_VAL)
            )?.toFixed(2)
          ),
        };

        setFormState((formState) => ({
          ...formState,
          invoicePORef_List: tempArray,
        }));
        checkBal(tempArray);
      }
    }
    // else if (name === "inpuT_QTY") {

    //   tempArray[rowIndex] = {
    //     ...formState.invoicePORef_List[rowIndex],
    //     inpuT_QTY: Number(tempArray[rowIndex].inpuT_QTY),
    //     inpuT_VAL:Number(((Number(tempArray[rowIndex].val_Loccur) /
    //     Number(tempArray[rowIndex].quantity)) *
    //   Number(tempArray[rowIndex].inpuT_QTY))?.toFixed(2))
    //       ,
    //   };
    //   setFormState((formState) => ({
    //     ...formState,
    //     invoicePORef_List: tempArray,
    //   }));
    //   checkBal(tempArray);
    //   // }
    // }
    else {
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    }
  };
  const AmountCell = React.memo(({ rowData, setRowData }) => {
    return (
      <TextField
        type="number"
        // name="amount"
        // size="small"
        // value={rowData?.amount}
        sx={{
          "& legend": { display: "none" },
          "& fieldset": { top: 0 },
        }}
        min={0}
        InputProps={{
          inputProps: { min: 0, step: "0.01" },
          disableUnderline: true,
        }}
        variant="standard"
        required
        value={rowData}
        onChange={(e) => setRowData(e.target.value)}
      />
    );
  });
  const intColumn = {
    component: AmountCell,
    deleteValue: () => "",
    copyValue: ({ rowData }) => rowData,
    pasteValue: ({ value }) => value,
  };
  const [columns, setColumns] = useState([
    {
      ...keyColumn("poItem", textColumn),
      title: "Item #",
      disabled: true,
    },
    {
      ...keyColumn("poNumber", textColumn),
      title: "PO Number",
      minWidth: 170,
      disabled: true,
    },
    {
      ...keyColumn("vText", textColumn),
      title: "Condition Text",
      disabled: true,
      minWidth: 200,
    },
    {
      ...keyColumn("refDoc", textColumn),
      title: "GRN No",
      minWidth: 200,
      disabled: true,
    },
    {
      ...keyColumn("quantity", textColumn),
      title: "GRN Quantity",
      width: 160,
      disabled: true,
    },
    {
      ...keyColumn("val_Loccur", textColumn),
      title: "GRN Amount",
      width: 160,
      disabled: true,
    },
    {
      ...keyColumn("invoicE_QTY", textColumn),
      title: "Consumed Quantity",
      width: 160,
      disabled: true,
    },
    {
      ...keyColumn("invoicE_VAL", textColumn),
      title: "Consumed Amount",
      width: 160,
      disabled: true,
    },
    {
      ...keyColumn("available_QTY", floatColumn),
      title: " Available Qty",
      minWidth: 160,
      disabled: true,
    },
     {
      ...keyColumn("uniT_PRICE", textColumn),
      title: "Unit Price",
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      ...keyColumn("available_VAL", floatColumn),
      minWidth: 160,
      title: "Available Amt",
      disabled: true,
    },
    {
      ...keyColumn("inpuT_QTY", floatColumn),
      pasteValue: ({ rowData, value, rowIndex }) => {
        rowData.inpuT_QTY = Number(value.replace(/,/g, "")) || 0;
        return rowData;
      },
      title: "Invoice Qty",
      disabled: edit,
      minWidth: 140,
    },
    {
      ...keyColumn("inpuT_VAL", floatColumn),
      pasteValue: ({ rowData, value, rowIndex }) => {
        rowData.inpuT_VAL = Number(value.replace(/,/g, "")) || 0;
        return rowData;
      },
      minWidth: 140,

      title: "Invoice Amt",
      disabled: edit,
    },
    {
      ...keyColumn("currency", textColumn),
      title: "Currency",
      disabled: true,
      grow: 2,
    },
    {
      ...keyColumn("poItemText", textColumn),
      title: " PO Text",
      disabled: true,
      minWidth: 200,
    },
    {
      ...keyColumn("plant", textColumn),
      title: "Plant",
      disabled: true,
    },
    


    {
      ...keyColumn("dN_NO", textColumn),
      title: "Delivery Note",
      disabled: true,
    },
    {
      ...keyColumn("assetNumber", textColumn),
      title: "Asset No",
      disabled: true,
    },
  ]);
  return (
    <div>
      <Grid container style={{ margin: "20px 0px" }}>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
          <Heading title="PO Details" />
          <>
            {/*   <TableContainer
            className="scrollable"
            style={{
              maxHeight: "400px",
              minHeight: "100px",
              overflowY: "auto",
              padding: "0px 5px",
            }}
          >
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
            >
              <TableHead style={{ position: "sticky", top: 0, zIndex: "1" }}>
                <TableRow sx={{backgroundColor: "#EFF2F4" }}>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bold", color: "#031c30" }}
                  >
                    #
                  </TableCell>
                  {checkedBox && (
                    <TableCell
                      sx={{ fontWeight: "bold", color: "#031c30" }}
                    ></TableCell>
                  )}
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Item #
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    PO Number
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Condition Text
                  </TableCell>
                   <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    PO Qty
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    PO Amt
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    GRN Qty
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    GRN Amt
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Consumed Qty
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Consumed Amt
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Invoice Qty
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Invoice Amt
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Currency
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    PO Text
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Plant
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Delivery Note
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Asset No.
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Text
                  </TableCell>
                  {deletee && (
                    <TableCell
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "#031c30",
                      }}
                    >
                      Action
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {formState?.invoicePORef_List?.length > 0 &&
                  formState?.invoicePORef_List?.map((item, index) => {
                    return (
                      <TableRow
                        key={index}
                        // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      >
                        <TableCell align="center" scope="row">
                          {index + 1}
                          {item.selected}
                        </TableCell>
                        {checkedBox && (
                          <TableCell>
                            <Checkbox
                              checked={item?.selected ? true : false}
                              onChange={(e) => {
                                selectRec(e, index);
                              }}
                            />
                          </TableCell>
                        )}
                        <TableCell>
                          <input
                            type="number"
                            className={classes.inputStyle}
                            size="small"
                            variant="standard"
                            name="poItem"
                            value={item?.poItem || item?.POItem}
                            // min="0"
                            disabled={true}
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="number"
                            className={classes.inputStyle}
                            size="small"
                            variant="standard"
                            name="poNumber"
                            value={item?.poNumber || item?.PONumber}
                            disabled={true}
                            // min="0"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>

                        <TableCell>
                          <input
                            type="number"
                            className={classes.inputStyle}
                            size="small"
                            variant="standard"
                            name="vText"
                            value={item?.vText || item?.vText}
                            disabled={true}
                            // min="0"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="Poqty"
                            value={item?.Poqty || item?.Poqty}
                            disabled={true}
                            min="0"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="number"
                            className={classes.inputStyle}
                            size="small"
                            variant="standard"
                            name="ammount"
                            value="not found"
                            disabled={true}
                            min="0"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                           
                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="quantity"
                            value={item?.quantity || item?.Quantity}
                            disabled={true}
                            // min="0"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>

                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="val_Loccur"
                            value={item?.val_Loccur || item?.Val_Loccur}
                            disabled={true}
                            // min="0"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="invoicE_QTY"
                            value={item?.invoicE_QTY || item?.invoicE_QTY}
                            disabled={true}
                            // min="0"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>

                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="invoicE_VAL"
                            value={item?.invoicE_VAL || item?.INVOICE_VAL}
                            disabled={true}
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="inpuT_QTY"
                            value={item?.inpuT_QTY || item?.INPUT_QTY || 0}
                            // min="0"
                            disabled={edit}
                            // min="0"
                            step="0.00001"
                            // max={
                            //   (item?.quantity || item?.Quantity) -
                            //   (item?.invoicE_QTY || item?.INVOICE_QTY)
                            // }
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="inpuT_VAL"
                            value={item?.inpuT_VAL || 0}
                            // min="0"
                            disabled={edit}
                            step="0.00001"
                            // min={(
                            //   (Number(item?.val_Loccur || item?.Val_Loccur) /
                            //     Number(item?.quantity || item?.Quantity)) *
                            //     Number(item?.inpuT_QTY || item?.INPUT_QTY) -
                            //   (Number(item?.val_Loccur || item?.Val_Loccur) /
                            //     Number(item?.quantity || item?.Quantity)) *
                            //     Number(item?.inpuT_QTY || item?.INPUT_QTY) *
                            //     0.05
                            // ).toFixed(0)}
                            // max={(
                            //   (Number(item?.val_Loccur || item?.Val_Loccur) /
                            //     Number(item?.quantity || item?.Quantity)) *
                            //     Number(item?.inpuT_QTY || item?.INPUT_QTY) +
                            //   (Number(item?.val_Loccur || item?.Val_Loccur) /
                            //     Number(item?.quantity || item?.Quantity)) *
                            //     Number(item?.inpuT_QTY || item?.INPUT_QTY) *
                            //     0.05
                            // ).toFixed(0)}
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="text"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="currency"
                            value={item?.currency || item?.Currency}
                            disabled={true}
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="text"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="POItemText"
                            value={item?.poItemText || item?.POItemText}
                            disabled={true}
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="Plant"
                            value={item?.plant || item?.Plant || 0}
                            disabled={true}
                            // min="0"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name=" DelivUnit "
                            value={item?.delivUnit || item?.DelivUnit || 0}
                            disabled={true}
                            // min="0"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="AssetNumber"
                            value={item?.assetNumber || item?.AssetNumber || 0}
                            disabled={true}
                            min="0"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="text"
                            size="small"
                            className={classes.inputStyle}
                            variant="standard"
                            name="VText"
                            value={item?.vText || item?.VText}
                            disabled={true}
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        {deletee && (
                          <TableCell align="center">
                            <IconButton size="small">
                              <Delete
                                color="error"
                                fontSize="small"
                                onClick={() => {
                                  deleteInput(index);
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })}
              </TableBody>
              {loading && <TableSkeleton noOfColumns={11} noOfLines={3} />}
            </Table>
            {formState?.length === 0 && !loading ? <EmptyData /> : ""}
          </TableContainer>*/}
          </>

          {formState.invoicePORef_List?.length === 0 && !loading ? (
            <EmptyData />
          ) : loading ? (
            <>
              <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
                <LinearProgress color="info" />
                <LinearProgress color="info" />
                <LinearProgress color="info" />
              </Stack>
            </>
          ) : (
            <DataSheetGrid
              style={{
                "--dsg-header-text-color": "#031C30",
              }}
              value={
                formState.invoicePORef_List.length === 0
                  ? tableData
                  : [
                      ...formState?.invoicePORef_List?.map((item) => {
                        return {
                          ...item,
                          currency:'PKR',
                          inpuT_VAL: Number(
                            Number(item?.inpuT_VAL)?.toFixed(2)
                          ),
                        };
                      }),
                    ]
              }
              // value={
              //   formState.invoicePORef_List.length === 0
              //     ? tableData
              //     : formState.invoicePORef_List
              // }
              onChange={handleGridChange}
              columns={columns}
              //  lockRows={(disabled || formState.invoicePORef_List.length === 0) ? true: false}
              lockRows={true}
              onActiveCellChange={(res) => {
                setCellState(res);
              }}

              // onDelete={handleDelete}
            />
          )}
          {/* {!disabled && (
            <Box display="flex" justifyContent={"flex-end"} mt={2}>
              <Button color="secondary" variant="contained" onClick={addInput}>
                Add New Row
              </Button>
            </Box>
          )} */}
        </Grid>
      </Grid>
    </div>
  );
}

export default React.memo(PoDetail_Table_Import);
